import React from 'react';
import { FiDollarSign, FiTrendingUp } from 'react-icons/fi';

const FinancialBunkerCard = ({ mrr, payout }) => {
    const format = (v) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0);

    return (
        <div className="col-span-full xl:col-span-3 p-1 rounded-[3rem] bg-gradient-to-br from-blue-600/20 via-transparent to-blue-900/20 border border-white/10 backdrop-blur-3xl shadow-2xl relative overflow-hidden group">
            <div className="bg-[var(--bg-card)] rounded-[2.8rem] p-10 flex flex-col md:flex-row items-center justify-between gap-12 relative z-10">
                <div className="space-y-2">
                    <span className="text-[10px] font-black uppercase tracking-[0.5em] text-blue-400">Receita Mensal (MRR)</span>
                    <h2 className="text-5xl font-black tracking-tighter text-white">{format(mrr)}</h2>
                </div>

                <div className="w-px h-20 bg-white/10 hidden md:block" />

                <div className="text-center md:text-right space-y-2">
                    <div className="flex items-center justify-center md:justify-end gap-3 text-emerald-400">
                        <FiTrendingUp size={18} />
                        <span className="text-[10px] font-black uppercase tracking-[0.5em]">Payout Projetado ($4.5\times$)</span>
                    </div>
                    <h2 className="text-6xl font-black tracking-tighter text-emerald-400 drop-shadow-[0_0_25px_rgba(52,211,153,0.3)]">
                        {format(payout)}
                    </h2>
                </div>
            </div>
            {/* Efeito de brilho de fundo */}
            <div className="absolute -right-20 -bottom-20 w-80 h-80 bg-blue-500/10 blur-[120px] rounded-full group-hover:bg-blue-500/20 transition-all duration-700" />
        </div>
    );
};

export default FinancialBunkerCard;